import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { MODAL } from '../../../../redux/types';

import { IPin } from '../../types/IPin';

import PinLoader from '../../loaders/pinLoader/pinLoader';
import Icon from '../../icon/icon';

import './pin.scss';

const Pin: React.FC<IPin> = ({ isPinned, clickHandler, className, loading }) => {
  const dispatch = useDispatch();

  const impersonate = useSelector((state: RootState) => state.impersonate.impersonate);

  const pinClickHandler = impersonate ? () => dispatch({ type: MODAL.SWITCH_IMPERSONATE_MODE_MODAL }) : clickHandler;

  return (
    <div className={'pin-wrapper'}>
      {loading && <PinLoader />}
      <Icon className={`${className ? className : ''} pointer ${isPinned ? 'pinned' : ''}`}
            name={`${isPinned ? 'fas' : 'far'} fa-thumbtack`} onClick={pinClickHandler} />
    </div>
  );
};

export default Pin;
